<!--
 * @Description: myredhat-web
 * @Version: 1.0
 * @Autor: 张梦洁
 * @Date: 2021-09-07 08:45:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-30 15:02:30
-->

<template>
  <div id="app">
    <!-- 顶部导航 -->
    <div class="topnav">
      <div class="inner clearfix">
        <a href="#" class="logo fl">
          <img src="../src/assets/logo.png" alt="">
        </a>
        <el-menu :default-active="activeIndex" class="el-menu-demo fr" active-text-color="#E1372E" mode="horizontal" :router="true">
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/Product">产品中心</el-menu-item>
          <el-menu-item index="/Solve">解决方案</el-menu-item>
          <el-menu-item index="/Cooperation">合作客户</el-menu-item>
          <el-menu-item index="/Consult">行业咨询</el-menu-item>
          <el-menu-item index="/About">关于我们</el-menu-item>
          <el-menu-item index="/Relation">联系我们</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <!-- <gongyong></gongyong> -->
    <inquiry ref="zixunForm">
    </inquiry>
    <reservation ref="reservation"></reservation>
  </div>
</template>

<script>
import './css/public.css'
import './css/App.css'

import gongyong from './components/gongyong'
import inquiry from './components/inquiry'/* 咨询 */
import reservation from './components/reservation'
export default {
  data() {
    return {
      activeIndex: this.$route.path
    }
  },
  created() {
    //获取浏览器#号后面的路径
    if (window.location.hash.split('#')[1] !== '/Home') {
      this.activeIndex = window.location.hash.split('#')[1]
      return false
    }
    this.activeIndex = '/'
  },
  components: {
    gongyong,
    inquiry,
    reservation,
  },
  methods: {
    showPage1() {
      this.$refs.zixunForm.showPage()
    },
    showPage2() {
      this.$refs.reservation.showRes()
    }
  }
}
</script>

<style>
</style>